var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[(_vm.$vuetify.breakpoint.mdAndUp)?_c('h1',{staticClass:"card-title display-2",domProps:{"textContent":_vm._s(_vm.value)}}):_c('h1',{directives:[{name:"resize-text",rawName:"v-resize-text"}],staticClass:"card-title font-weight-light",domProps:{"textContent":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }